export const productsData = {
  // MUJI敏感肌化妝水(清爽型)/300ml
  4550583434939: {
    name: 'MUJI敏感肌化妝水(清爽型)/300ml',
    number: '4550583434939',
    price: '250',
    img: {
      white_bg: '4550583434939_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌化妝水(滋潤型)/300ml
  4550583434960: {
    name: 'MUJI敏感肌化妝水(滋潤型)/300ml',
    number: '4550583434960',
    price: '250',
    img: {
      white_bg: '4550583434960_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌化妝水(保濕型)/300ml
  4550583434991: {
    name: 'MUJI敏感肌化妝水(保濕型)/300ml',
    number: '4550583434991',
    price: '250',
    img: {
      white_bg: '4550583434991_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌乳液(清爽型)/200ml
  4550583435011: {
    name: 'MUJI敏感肌乳液(清爽型)/200ml',
    number: '4550583435011',
    price: '250',
    img: {
      white_bg: '4550583435011_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌乳液(滋潤型)/200ml
  4550583435035: {
    name: 'MUJI敏感肌乳液(滋潤型)/200ml',
    number: '4550583435035',
    price: '250',
    img: {
      white_bg: '4550583435035_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌乳液(保濕型)/200ml
  4550583435059: {
    name: 'MUJI敏感肌乳液(保濕型)/200ml',
    number: '4550583435059',
    price: '250',
    img: {
      white_bg: '4550583435059_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌ALL IN ONE美容凝膠.攜帶型/30g
  4550583435073: {
    name: 'MUJI敏感肌ALL IN ONE美容凝膠.攜帶型/30g',
    number: '4550583435073',
    price: '110',
    img: {
      white_bg: '4550583435073_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌ALL IN ONE美容凝膠/150g
  4550583435080: {
    name: 'MUJI敏感肌ALL IN ONE美容凝膠/150g',
    number: '4550583435080',
    price: '290',
    img: {
      white_bg: '4550583435080_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌保濕乳霜/50g
  4550583435110: {
    name: 'MUJI敏感肌保濕乳霜/50g',
    number: '4550583435110',
    price: '290',
    img: {
      white_bg: '4550583435110_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌化妝水(清爽型).攜帶型/50ml
  4550583483227: {
    name: 'MUJI敏感肌化妝水(清爽型).攜帶型/50ml',
    number: '4550583483227',
    price: '99',
    img: {
      white_bg: '4550583483227_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌化妝水(滋潤型).攜帶型/50ml
  4550583483234: {
    name: 'MUJI敏感肌化妝水(滋潤型).攜帶型/50ml',
    number: '4550583483234',
    price: '99',
    img: {
      white_bg: '4550583483234_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌化妝水(保濕型).攜帶型/50ml
  4550583483241: {
    name: 'MUJI敏感肌化妝水(保濕型).攜帶型/50ml',
    number: '4550583483241',
    price: '99',
    img: {
      white_bg: '4550583483241_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌乳液(清爽型).攜帶型/50ml
  4550583483258: {
    name: 'MUJI敏感肌乳液(清爽型).攜帶型/50ml',
    number: '4550583483258',
    price: '99',
    img: {
      white_bg: '4550583483258_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌乳液(滋潤型).攜帶型/50ml
  4550583483265: {
    name: 'MUJI敏感肌乳液(滋潤型).攜帶型/50ml',
    number: '4550583483265',
    price: '99',
    img: {
      white_bg: '4550583483265_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI敏感肌乳液(保濕型).攜帶型/50ml
  4550583483272: {
    name: 'MUJI敏感肌乳液(保濕型).攜帶型/50ml',
    number: '4550583483272',
    price: '99',
    img: {
      white_bg: '4550583483272_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 清新化妝水.乳液體驗組/3ml&3ml
  4711441361792: {
    name: '清新化妝水.乳液體驗組/3ml&3ml',
    number: '4711441361792',
    price: '59',
    img: {
      white_bg: '4711441361792_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 清新洗面乳/150g
  4711441361716: {
    name: '清新洗面乳/150g',
    number: '4711441361716',
    price: '290',
    img: {
      white_bg: '4711441361716_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 清新潔淨泥膜/150g
  4711441361723: {
    name: '清新潔淨泥膜/150g',
    number: '4711441361723',
    price: '490',
    img: {
      white_bg: '4711441361723_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 清新角質調理化妝水/300ml
  4711441361730: {
    name: '清新角質調理化妝水/300ml',
    number: '4711441361730',
    price: '390',
    img: {
      white_bg: '4711441361730_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 清新化妝水/300ml
  4711441361747: {
    name: '清新化妝水/300ml',
    number: '4711441361747',
    price: '390',
    img: {
      white_bg: '4711441361747_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 清新化妝水(保濕型)/300ml
  4711441361754: {
    name: '清新化妝水(保濕型)/300ml',
    number: '4711441361754',
    price: '390',
    img: {
      white_bg: '4711441361754_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 清新乳液/200ml
  4711441361761: {
    name: '清新乳液/200ml',
    number: '4711441361761',
    price: '390',
    img: {
      white_bg: '4711441361761_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 清新ALL IN ONE美容凝膠/150g
  4711441361778: {
    name: '清新ALL IN ONE美容凝膠/150g',
    number: '4711441361778',
    price: '390',
    img: {
      white_bg: '4711441361778_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 清新皮脂平衡局部精華/10g
  4711441361785: {
    name: '清新皮脂平衡局部精華/10g',
    number: '4711441361785',
    price: '390',
    img: {
      white_bg: '4711441361785_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 清新乳霜/45g
  4711441362072: {
    name: '清新乳霜/45g',
    number: '4711441362072',
    price: '390',
    img: {
      white_bg: '4711441362072_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 米糠發酵導入美容液/50ml
  4711441360559: {
    name: '米糠發酵導入美容液/50ml',
    number: '4711441360559',
    price: '490',
    img: {
      white_bg: '4711441360559_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 米糠發酵化妝水/300ml
  4711441361334: {
    name: '米糠發酵化妝水/300ml',
    number: '4711441361334',
    price: '490',
    img: {
      white_bg: '4711441361334_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 米糠發酵精華液/50ml
  4711441361341: {
    name: '米糠發酵精華液/50ml',
    number: '4711441361341',
    price: '490',
    img: {
      white_bg: '4711441361341_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 米糠發酵乳液/200ml
  4711441361358: {
    name: '米糠發酵乳液/200ml',
    number: '4711441361358',
    price: '490',
    img: {
      white_bg: '4711441361358_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 米糠發酵乳霜/45g
  4711441361365: {
    name: '米糠發酵乳霜/45g',
    number: '4711441361365',
    price: '490',
    img: {
      white_bg: '4711441361365_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 米糠發酵眼霜/20g
  4711441360535: {
    name: '米糠發酵眼霜/20g',
    number: '4711441360535',
    price: '490',
    img: {
      white_bg: '4711441360535_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 米糠發酵ALL IN ONE美容凝膠/150g
  4711441360542: {
    name: '米糠發酵ALL IN ONE美容凝膠/150g',
    number: '4711441360542',
    price: '490',
    img: {
      white_bg: '4711441360542_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI水漾潤澤化妝水/300ml
  4550583451141: {
    name: 'MUJI水漾潤澤化妝水/300ml',
    number: '4550583451141',
    price: '590',
    img: {
      white_bg: '4550583451141_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI水漾潤澤乳液/200ml
  4550583451158: {
    name: 'MUJI水漾潤澤乳液/200ml',
    number: '4550583451158',
    price: '590',
    img: {
      white_bg: '4550583451158_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI水漾潤澤乳霜/45g
  4550583451165: {
    name: 'MUJI水漾潤澤乳霜/45g',
    number: '4550583451165',
    price: '590',
    img: {
      white_bg: '4550583451165_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI水漾潤澤化妝水.攜帶型/50ml
  4550583483319: {
    name: 'MUJI水漾潤澤化妝水.攜帶型/50ml',
    number: '4550583483319',
    price: '150',
    img: {
      white_bg: '4550583483319_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI水漾潤澤乳液.攜帶型/50ml
  4550583483326: {
    name: 'MUJI水漾潤澤乳液.攜帶型/50ml',
    number: '4550583483326',
    price: '150',
    img: {
      white_bg: '4550583483326_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI水漾潤澤ALL IN ONE美容面霜
  4550583451189: {
    name: 'MUJI水漾潤澤ALL IN ONE美容面霜',
    number: '4550583451189',
    price: '590',
    img: {
      white_bg: '4550583451189_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 美白化妝水/300ml
  4711441361303: {
    name: '美白化妝水/300ml',
    number: '4711441361303',
    price: '490',
    img: {
      white_bg: '4711441361303_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 美白精華液/50ml
  4711441361310: {
    name: '美白精華液/50ml',
    number: '4711441361310',
    price: '490',
    img: {
      white_bg: '4711441361310_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 美白面霜/50g
  4711441360245: {
    name: '美白面霜/50g',
    number: '4711441360245',
    price: '490',
    img: {
      white_bg: '4711441360245_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI角質調理化妝水/300ml
  4550583451325: {
    name: 'MUJI角質調理化妝水/300ml',
    number: '4550583451325',
    price: '390',
    img: {
      white_bg: '4550583451325_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // MUJI角質調理化妝水.攜帶型/50ml
  4550583483302: {
    name: 'MUJI角質調理化妝水.攜帶型/50ml',
    number: '4550583483302',
    price: '99',
    img: {
      white_bg: '4550583483302_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 高濃度美容液 維他命C誘導體/50ml
  4711441362089: {
    name: '高濃度美容液 維他命C誘導體/50ml',
    number: '4711441362089',
    price: '790',
    img: {
      white_bg: '4711441362089_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 高濃度美容液 A醇誘導體/50ml
  4711441362096: {
    name: '高濃度美容液 A醇誘導體/50ml',
    number: '4711441362096',
    price: '790',
    img: {
      white_bg: '4711441362096_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 高濃度ALL IN ONE 美容精華凝膠/100g
  4711441362102: {
    name: '高濃度ALL IN ONE 美容精華凝膠/100g',
    number: '4711441362102',
    price: '790',
    img: {
      white_bg: '4711441362102_1260.jpg',
      usage: '',
    },
    alt: '',
  },
};

export const problemsData = [
  {
    id: 1,
    anchorTarget: '.categoryItem1',
    img: 'series-sensitive-skin.jpg',
    label: '',
    title: '敏感肌臉部保養系列',
    subtitle: '溫和保養，專為敏感肌打造。',
    checkList: ['在意肌膚乾燥', '容易在季節交替時感到不適', '容易感到刺激'],
  },
  {
    id: 2,
    anchorTarget: '.categoryItem2',
    img: 'clearcare-1.jpg',
    label: '台灣<br />企劃',
    title: '清新臉部保養系列',
    subtitle: '溫和調理毛孔，平衡肌膚狀態。',
    checkList: ['容易出油的肌膚', '想維持皮脂平衡', '在意粉刺毛孔問題', '想調整粗糙肌膚'],
  },
  {
    id: 3,
    anchorTarget: '.categoryItem4',
    img: 'ricebran.jpg',
    label: '台灣<br />企劃',
    title: '米糠發酵臉部保養系列',
    subtitle: '溫和滲透肌膚，​水潤好吸收。',
    checkList: ['在意肌膚暗沉', '想維持肌膚緊緻', '想要水潤光澤', '喜歡質地輕盈'],
  },
  {
    id: 4,
    anchorTarget: '.categoryItem5',
    img: 'series-aging-care.jpg',
    label: '',
    title: '水漾潤澤臉部保養系列',
    subtitle: '賦予乾燥、適齡肌膚彈性與潤澤。',
    checkList: ['肌膚容易乾燥', '想維持光滑緊緻', '在意失去彈性的肌膚'],
  },
  {
    id: 5,
    anchorTarget: '.categoryItem6',
    img: 'brightening.jpg',
    label: '台灣<br />企劃',
    title: '美白臉部保養系列',
    subtitle: '清爽不黏膩，保持肌膚白皙水潤。',
    checkList: ['在意膚色不均', '想要透亮白皙', '想要水嫩滋潤', '喜歡清爽質地'],
  },
  {
    id: 6,
    anchorTarget: '.categoryItem7',
    img: 'other-highly-concentrated-serum.jpg',
    label: '台灣<br />企劃',
    title: '高濃度美容液系列',
    subtitle: '溫和結合成分特性提升護膚效能。',
    checkList: ['增強肌膚防禦力', '在意瑕疵想要改善膚質', '想要肌膚嫩白、改善暗沉', '想要調理角質，緊緻毛孔'],
  },
];

export const seriesData = [
  {
    id: 1,
    category: {
      color: '#ccb397',
      img: 'series-sensitive-skin.jpg',
      label: '',
      title: '敏感肌臉部保養系列',
      description: '低刺激性，專為敏感肌打造，提供肌膚水感潤澤。',
      ingredients: ['神經醯胺<sup>*1</sup>', '5種胺基酸<sup>*2</sup>', '3種植物精華<sup>*3</sup>'],
      features: ['無色素', '無香料', '無酒精', '無礦物油', '無苯氧乙醇', '無苯甲酸酯類防腐劑'],
      note: '*並非保證所有人都不會產生過敏或皮膚刺激反應。',
    },
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583434939'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583434991'],
      },
      {
        id: 3,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583435011'],
      },
      {
        id: 4,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583435059'],
      },
      {
        id: 5,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583435080'],
      },
      {
        id: 6,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583435110'],
      },
    ],
    moreBtn: {
      img: 'btn-sensitive-skin.jpg',
      text: '敏感肌臉部保養系列特集',
      url: 'https://www.muji.tw/tw/feature/25ss/sensitiveskin/',
    },
    note: '*1保濕潤澤成分 *2 5種胺基酸：丙胺酸、精胺酸、谷氨酸鈉、絲胺酸、脯胺酸 *3 3種植物精華：尤加利葉萃取物、馬齒莧萃取物丶葡萄柚籽萃取物',
  },
  {
    id: 2,
    category: {
      color: '#6a97a6',
      img: 'clearcare-1.jpg',
      label: '台灣企劃',
      title: '清新臉部保養系列',
      description: '清爽質地，調整毛孔問題，維持肌膚皮脂平衡，不致粉刺<sup>*1</sup>。',
      ingredients: ['甘草酸二鉀', '14種植物精華<sup>*2</sup>'],
      features: ['無色素', '無合成香料', '無酒精', '無礦物油', '無苯甲酸酯類防腐劑'],
      note: '*無法保證所有人皆不會出現過敏或粉刺（痘痘）情況。',
    },
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361730'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361747'],
      },
      {
        id: 3,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361761'],
      },
      {
        id: 4,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441362072'],
      },
      {
        id: 5,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361785'],
      },
      {
        id: 6,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361778'],
      },
    ],
    // moreBtn: {},
    note: '*1 20位18~60歲健康受試者，在背部進行連續4週貼片測試後經皮膚科醫生臨床評估結果。<br />*2 14種植物精華：積雪草萃取、葡萄葉萃取、蘋果萃取、魚腥草萃取、菜薊萃取、香檬萃取、薏仁萃取、大豆萃取、柚子萃取、檸檬草萃取、越橘葉萃取、枇杷葉萃取、茶樹葉油萃取、西洋梨果汁發酵液。',
  },
  {
    id: 3,
    category: {
      color: '#6a97a6',
      img: 'clearcare-2.jpg',
      label: '台灣企劃',
      title: '清新臉部清潔系列',
      description: '溫和清潔毛孔，維持肌膚皮脂平衡，不致粉刺<sup>*1</sup>。',
      ingredients: ['甘草酸二鉀', '14種植物精華<sup>*2</sup>'],
      features: ['無合成香料', '無酒精', '無礦物油', '無苯甲酸酯類防腐劑'],
      note: '*並非保證所有人都不會產生過敏或皮膚刺激反應。',
    },
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361716'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361723'],
      },
    ],
    moreBtn: {
      img: 'btn-clearcare-feature.jpg',
      text: '清新臉部保養系列特集',
      url: 'https://www.muji.tw/tw/feature/25ss/clearcare/',
    },
    note: '*1 20位18~60歲健康受試者，在背部進行連續4週貼片測試後經皮膚科醫生臨床評估結果。<br />*2 14種植物精華：積雪草萃取、葡萄葉萃取、蘋果萃取、魚腥草萃取、菜薊萃取、香檬萃取、薏仁萃取、大豆萃取、柚子萃取、檸檬草萃取、越橘葉萃取、枇杷葉萃取、茶樹葉油萃取、西洋梨果汁發酵液。',
  },
  {
    id: 4,
    category: {
      color: '#a3808a',
      img: 'ricebran.jpg',
      label: '台灣企劃',
      title: '米糠發酵臉部保養系列',
      description: '溫和滲透肌膚，打造彈性光澤肌。',
      ingredients: ['米糠發酵液', '柑橘、菜薊植物萃取精華成分', '玻尿酸鈉<sup>*</sup>'],
      features: ['無色素', '無香料', '無酒精', '無礦物油', '無苯甲酸酯類防腐劑'],
      note: '',
    },
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441360559'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361334'],
      },
      {
        id: 3,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361341'],
      },
      {
        id: 4,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361358'],
      },
      {
        id: 5,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361365'],
      },
      {
        id: 6,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441360535'],
      },
      {
        id: 7,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441360542'],
      },
    ],
    moreBtn: {
      img: 'btn-ricebran-feature.jpg',
      text: '米糠發酵臉部保養系列',
      url: 'https://www.muji.tw/tw/feature/24ss/ricebran/',
    },
    note: '*保濕成分',
  },
  {
    id: 5,
    category: {
      color: '#a3808a',
      img: 'series-aging-care.jpg',
      label: '',
      title: '水漾潤澤臉部保養系列',
      description: '賦予適齡、乾燥肌膚飽滿彈性、豐盈潤澤。',
      ingredients: [
        '視黃醇(A醇)誘導體​<sup>*1</sup>',
        '維他命C誘導體<sup>*2</sup>',
        '米糠發酵液<sup>*3</sup>',
        '神經醯胺<sup>*3</sup>',
        '5種胺基酸<sup>*4</sup>',
        '11種植物精華<sup>*5</sup>',
      ],
      features: ['無色素', '無合成香料', '無酒精', '無礦物油', '無苯甲酸酯類防腐劑'],
      note: '',
    },
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583451141'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583451158'],
      },
      {
        id: 3,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583451165'],
      },
      {
        id: 4,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583451189'],
      },
    ],
    moreBtn: {
      img: 'btn-aging-care-feature.jpg',
      text: '水漾潤澤臉部保養系列​​特集',
      url: 'https://www.muji.tw/tw/feature/25aw/lustreglass/',
    },
    note: '*1 視黃醇棕櫚酸酯 *2 抗壞血酸四己基癸酸酯 *3 保濕成分 *4 5 種胺基酸：丙氨酸、精氨酸、谷氨酸鈉、絲氨酸、脯氨酸 *5 11種植物精華：桑白皮萃取、黃柏樹皮萃取、玫瑰花萃取、矢車菊花萃取、薰衣草花萃取、苦橙果皮萃取、檸檬果汁萃取、虎耳草萃取、艾葉萃取、迷迭香葉萃取、昆布萃取。',
  },
  {
    id: 6,
    category: {
      color: '#e0ceaa',
      img: 'brightening.jpg',
      label: '台灣企劃',
      title: '美白臉部保養系列',
      description: '清爽不黏膩,保持肌膚白皙水潤。',
      ingredients: [
        '維生素C糖苷<sup>*1</sup>',
        '菸鹼醯胺​<sup>*2</sup>',
        '玻尿酸鈉<sup>*3</sup>',
        '依蘭、橘皮萃取精華',
      ],
      features: ['無色素', '無香料', '無酒精', '無礦物油', '無苯甲酸酯類防腐劑'],
      note: '*並非保證所有人都不會產生過敏或皮膚刺激反應。',
    },
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361303'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441361310'],
      },
      {
        id: 3,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441360245'],
      },
    ],
    // moreBtn: {},
    note: '*1 美白成分：改善肌膚暗沉、膚色不均 *2 提升肌膚對環境傷害的抵抗力及抗氧化力 *3 保濕成分',
  },
  {
    id: 7,
    category: {
      color: '#ccb397',
      img: 'other-highly-concentrated-serum.jpg',
      label: '台灣企劃',
      title: '高濃度美容液系列',
      description: '溫和結合成分特性提升護膚效能。',
      ingredients: [
        '維他命C誘導體​<sup>*1</sup>',
        '視黃醇(A醇)誘導體<sup>*2</sup>',
        '菸鹼醯胺<sup>*3</sup>',
        '玻尿酸鈉​<sup>*4</sup>',
      ],
      features: ['無色素', '無香料', '無酒精', '無礦物油', '無苯甲酸酯類防腐劑'],
      note: '*並非保證所有人都不會產生過敏或皮膚刺激反應。<br />*高濃度：與本公司商品比較',
    },
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441362089'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441362096'],
      },
      {
        id: 3,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4711441362102'],
      },
    ],
    // moreBtn: {},
    note: '*1 抗壞血酸四己基癸酸酯 *2 視黃醇棕櫚酸酯 *3 提升肌膚對環境傷害的抵抗力 *4 保濕成分 *5 A醇對紫外線非常敏感，容易氧化分解導致成分失效。人體肌膚自我修復與更新代謝機制多集中在夜間進行，晚上使用能有效配合生理節奏，提升修護與代謝效果。',
  },
];

export const seriesOtherData = [
  {
    id: 1,
    category: {
      img: 'other-wiping-lotion.jpg',
      label: '',
      title: '角質調理化妝水',
      description: '植物萃取保濕成分，讓肌膚擁有透明感。',
      features: ['無色素', '無香料', '無酒精', '無礦物油', '無苯氧乙醇', '無苯甲酸酯類防腐劑'],
      note: '*並非保證所有人都不會產生過敏或皮膚刺激反應。',
    },
    products: [
      {
        id: 1,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583451325'],
      },
      {
        id: 2,
        current_index: 0,
        no_chips: true,
        tag: '',
        items: ['4550583483302'],
      },
    ],
  },
  // {
  //   id: 2,
  //   category: {
  //     img: 'other-highly-concentrated-serum.jpg',
  //     label: '台灣企劃',
  //     title: '高濃度美容液系列',
  //     description: '溫和結合成分特性，提升日常護膚效能。',
  //     features: ['無色素', '無香料', '無酒精', '無礦物油', '無苯氧乙醇', '無苯甲酸酯類防腐劑'],
  //     note: '',
  //   },
  //   products: [
  //     {
  //       id: 1,
  //       current_index: 0,
  //       no_chips: true,
  //       tag: '',
  //       items: ['4711441362089'],
  //     },
  //     {
  //       id: 2,
  //       current_index: 0,
  //       no_chips: true,
  //       tag: '',
  //       items: ['4711441362096'],
  //     },
  //     {
  //       id: 3,
  //       current_index: 0,
  //       no_chips: true,
  //       tag: '',
  //       items: ['4711441362102'],
  //     },
  //   ],
  // },
];

export const reportData = [
  {
    id: 1,
    link: 'https://www.muji.tw/tw/feature/25ss/sensitiveskin/',
    img: 'special01.jpg',
    text: '敏感肌臉部保養系列',
  },
  {
    id: 2,
    link: 'https://www.muji.tw/tw/feature/25ss/clearcare/',
    img: 'special02.jpg',
    text: '清新臉部保養系列',
  },
  {
    id: 3,
    link: 'https://www.muji.tw/tw/feature/24ss/ricebran/',
    img: 'special03.jpg',
    text: '米糠發酵臉部保養系列',
  },
  {
    id: 4,
    link: 'https://www.muji.tw/tw/feature/25aw/lustreglass/',
    img: 'special04.jpg',
    text: '水漾潤澤臉部保養系列',
  },
  {
    id: 5,
    link: 'https://www.muji.tw/tw/feature/25ss/fragrant-tw/',
    img: 'special05.jpg',
    text: '台灣精油',
  },
  {
    id: 6,
    link: 'https://www.muji.tw/tw/feature/fragrance/',
    img: 'special06.jpg',
    text: '香氣・空間香氛',
  },
];
